import request from '@/utils/request'
import { disPostParams } from '@/utils/common.js'
import { getId } from '@/utils/auth'

export function getConfigs(data) {
    return request({
        url: "/app/ufconfig/getConfigs",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}

export function getConfig(data) {
    return request({
        url: "/app/ufconfig/getconfig",
        headers: {
            isToken: false,
        },
        method: 'post',
        data: disPostParams(data)
    });
}


// WEBPACK FOOTER //
// ./src/api/spreader/config.js